/* HTB03 nativefinal v6 behavior parity 2026-06-11: exact source date replacement + product-intro sticky trigger */
(function(){
  var ROOT_ID='htb07-gel-final';
  var INTRO_SELECTOR='#htb07gel-itksswy';
  var INTRO_TEXT='INTRODUCING THE DEVICE THAT ACTUALLY RELIEVES HIP PAIN';
  function ready(fn){ if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fn,{once:true});} else fn(); }
  function root(){ return document.getElementById(ROOT_ID); }
  function norm(s){ return (s||'').replace(/\s+/g,' ').trim(); }
  function suffix(n){return (n%10==1&&n%100!=11)?'st':(n%10==2&&n%100!=12)?'nd':(n%10==3&&n%100!=13)?'rd':'th';}
  function sourcePublishedDate(){
    var d=new Date(); d.setDate(d.getDate()-2);
    var days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return days[d.getDay()]+' . '+months[d.getMonth()]+' . '+d.getDate()+' '+suffix(d.getDate())+' , '+d.getFullYear()+' | 11:11 am EST';
  }
  function applySourceDate(r){
    // Text-node-only replacement. Never rewrite root.innerHTML: that reparses malformed exported DOM and resurrects old sidebar state.
    var txt=sourcePublishedDate();
    var rx=/[A-Z][a-z]{2}\s*\.\s*[A-Z][a-z]{2}\s*\.\s*\d{1,2}\s*(?:st|nd|rd|th)\s*,\s*20\d{2}\s*\|\s*11:11\s*am\s*EST/g;
    var w=document.createTreeWalker(r,NodeFilter.SHOW_TEXT); var nodes=[];
    while(w.nextNode()) nodes.push(w.currentNode);
    nodes.forEach(function(n){ if(rx.test(n.nodeValue)){ n.nodeValue=n.nodeValue.replace(rx,txt); } rx.lastIndex=0; });
  }
  function findIntro(r){
    var direct=r.querySelector(INTRO_SELECTOR);
    if(direct && norm(direct.textContent).indexOf(INTRO_TEXT)!==-1) return direct;
    var nodes=r.querySelectorAll('h1,h2,h3,h4,div,p,span');
    for(var i=0;i<nodes.length;i++){
      if(norm(nodes[i].textContent)===INTRO_TEXT || norm(nodes[i].textContent).indexOf(INTRO_TEXT)!==-1) return nodes[i];
    }
    return null;
  }
  function bindSticky(r){
    var sticky=r.querySelector('.htb07gel-sticky, #htb07gel-ix4a36-4-5');
    if(!sticky) return;
    var trigger=findIntro(r);
    function setVisible(v){ r.classList.toggle('htb07gel-sticky-visible', !!v); sticky.setAttribute('aria-hidden', v?'false':'true'); }
    function update(){
      if(!trigger){ setVisible(window.scrollY>700); return; }
      var rect=trigger.getBoundingClientRect();
      // Reveal only when product-introduction section reaches viewport, not at generic early scroll depth.
      setVisible(rect.top <= window.innerHeight && rect.bottom >= 0 || rect.top < 0);
    }
    setVisible(false); update();
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    if('IntersectionObserver' in window && trigger){
      var io=new IntersectionObserver(update,{root:null,threshold:[0,0.01],rootMargin:'0px 0px 0px 0px'});
      io.observe(trigger);
    }
  }
  ready(function(){ var r=root(); if(!r) return; applySourceDate(r); bindSticky(r); });
})();


;/* pain-gel-report-sidebar-repair-20260628-js-asset */
(function(){
  function repairPainGelSidebar(){
    var root=document.getElementById('htb07-gel-final');
    var shell=document.getElementById('htb07gel-ialx1');
    var sidebar=document.getElementById('htb07gel-iaxmo');
    if(!root||!shell||!sidebar) return;
    if(window.matchMedia&&window.matchMedia('(min-width: 1000px)').matches){
      if(sidebar.parentElement!==shell) shell.appendChild(sidebar);
      document.documentElement.setAttribute('data-pain-gel-sidebar-repaired','1');
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',repairPainGelSidebar); else repairPainGelSidebar();
  window.addEventListener('resize',repairPainGelSidebar);
})();


;/* pain-gel-report-original-link-sidebar-image-fix-20260628 */
(function(){
  function setImg(wrapperId, src, alt){
    var w=document.getElementById(wrapperId); if(!w) return false;
    var img=w.querySelector('img'); if(!img) return false;
    img.src=src; img.alt=alt; img.style.display='block'; img.style.width='100%'; img.style.height='auto';
    return true;
  }
  function repairOriginalPainGelReport(){
    if(location.pathname!=='/pages/pain-gel-report') return;
    var root=document.getElementById('htb07-gel-final');
    var shell=document.getElementById('htb07gel-ialx1');
    var article=document.getElementById('htb07gel-ipgb6');
    var sidebar=document.getElementById('htb07gel-iaxmo');
    if(!root||!shell||!article||!sidebar) return;
    if(window.matchMedia && window.matchMedia('(min-width:1000px)').matches){
      shell.style.display='flex'; shell.style.flexDirection='row'; shell.style.flexWrap='wrap'; shell.style.alignItems='flex-start'; shell.style.justifyContent='center'; shell.style.gap='28px';
      article.style.flex='0 0 760px'; article.style.width='760px'; article.style.maxWidth='760px';
      sidebar.style.flex='0 0 320px'; sidebar.style.width='320px'; sidebar.style.maxWidth='320px'; sidebar.style.marginTop='0'; sidebar.style.alignSelf='flex-start'; sidebar.style.position='sticky'; sidebar.style.top='20px';
      if(sidebar.parentElement!==shell) shell.appendChild(sidebar);
    }
    setImg('htb07gel-ie7d56','https://cdn.shopify.com/s/files/1/0824/5349/6154/t/13/assets/htb02-sidebar-review-linda-peterson-controller-pocket-product-photo-20260501.png?v=1777664050','Marilyn Cooper review photo showing the Daywick Hip Therapy Belt controller pocket');
    setImg('htb07gel-iyzmil','https://cdn.shopify.com/s/files/1/0824/5349/6154/t/13/assets/htb02-sidebar-review-brad-jenkins-red-light-panel-product-photo-20260501.png?v=1777664047','Mark Reynolds review photo showing the Daywick Hip Therapy Belt red light panel');
    setImg('htb07gel-i3pxa9','https://cdn.shopify.com/s/files/1/0824/5349/6154/t/13/assets/htb02-why-would-i-do-this-customer-collage-user-approved-20260503.png?v=1777822028','Carol Watkins customer proof collage showing at-home hip relief');
    sidebar.setAttribute('data-sidebar-original-link-images-fixed','20260628');
    document.documentElement.setAttribute('data-pain-gel-original-link-fixed','1');
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',repairOriginalPainGelReport); else repairOriginalPainGelReport();
  window.addEventListener('resize',repairOriginalPainGelReport);
})();
